import React, { useEffect, useState } from 'react';
import { slugify, flatDeep, containsObject } from '../../../utils';
import { Link } from 'react-router-dom';

const SideCategories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('token');

    fetch(`${process.env.REACT_APP_API_BASE_URL}/contents`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        // Extract all categories from contents, flatten nested arrays
        const cats = data.map((item) => item.categories || []);
        const singleCatArray = flatDeep(cats);

        const categoryCounts = [];

        singleCatArray.forEach((cat) => {
          const obj = {
            title: cat.trim(),
            slug: slugify(cat),
            count: 1,
          };

          const objIndex = containsObject(obj, categoryCounts);
          if (objIndex !== -1) {
            categoryCounts[objIndex].count += 1; // increment count if exists
          } else {
            categoryCounts.push(obj); // add new category
          }
        });

        setCategories(categoryCounts);
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  }, []);

  return (
    <ul className="category-list">
      {categories.map((cat) => (
        <li key={cat.slug}>
          <Link to={`${process.env.PUBLIC_URL}/category/${cat.slug}`}>
            <span className="left-content">{cat.title}</span>
            <span className="count-text">{cat.count}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default SideCategories;
